import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import { i18nextConfig, type LanguageResource } from "@newtri/core";

declare module "i18next" {
	interface CustomTypeOptions {
		defaultNS: "web";
		resources: LanguageResource;
	}
}

i18next
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({ ...i18nextConfig, defaultNS: "web" });
